import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/recepciones';
import Home from './Home';


const ms2p = (state) => {
    let cambio_dolar = 0;
    const configuraciones = state.configuracion.configuraciones;
    if (configuraciones.cambio_dolar) {
        cambio_dolar = configuraciones.cambio_dolar.cambio_dolar;
    }
    return {
        ...state.recepciones,
        me: state.login.me,
        proveedor: state.login.proveedor,
        cambio_dolar,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Home);
